// src/lib/sample-data/platform-configs.ts
import type { PlatformCurrency, PlatformLanguage, Sport } from '@/lib/types';
import { LANGUAGES as INITIAL_LANGUAGES, SPORTS as INITIAL_SPORTS } from '@/lib/constants';

export const samplePlatformCurrencies: PlatformCurrency[] = [
  { code: 'CHF', name: 'Swiss Franc', symbol: 'Fr.', isActive: true, isDefault: true },
  { code: 'EUR', name: 'Euro', symbol: '€', isActive: true, isDefault: false },
  { code: 'USD', name: 'US Dollar', symbol: '$', isActive: true, isDefault: false },
  { code: 'GBP', name: 'British Pound', symbol: '£', isActive: true, isDefault: false },
];

export const samplePlatformLanguages: PlatformLanguage[] = INITIAL_LANGUAGES.map(lang => ({
  ...lang,
  isActive: true,
}));

export const sampleSportsData: Sport[] = INITIAL_SPORTS.map(sport => ({
  id: sport.id || sport.name.toLowerCase().replace(/\s+/g, '-'),
  name: sport.name,
  icon: sport.icon,
  color: sport.color || '#AECAFD', // Default color if not specified in constants
}));
